import React, { useState, forwardRef, useEffect, useImperativeHandle } from 'react';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from "react-select";

const PartForm = forwardRef((props, ref) => {
  const [partModal, setPartModal] = useState(false);
  const [formData, setFormData] = useState({
    PartID: '',
    PartName: '',
    PartNumber: '',
    Cost: '0',
    StockQuantity: '',
    SupplierID: '',
    VehicleCompatibility: '',
    ProductCode: '',
    PurchasePrice: '0',
    Manufacturer: '',
    CountryOfManufacture: '',
    Photo: null, // To store photo as a file
    Notes: '',
    Status: 'Available',
    PartClassID: '', // New field for PartClassID
  });

  const [suppliers, setSuppliers] = useState([]);
  const [partClasses, setPartClasses] = useState([]); // New state for part classes
  const [errors, setErrors] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null); // Photo preview state

  // Fetch Suppliers and Part Classes from the API
     const fetchSuppliersAndPartClasses = async () => {
      try {
        // Fetch Suppliers
        const suppliersResponse = await axios.get('https://subk.education.com.ly/back/api/suppliers'); // Adjust your API endpoint
        setSuppliers(suppliersResponse.data);

        // Fetch Part Classes
        const partClassesResponse = await axios.get('https://subk.education.com.ly/back/api/getPartClacess'); // Adjust your API endpoint
        setPartClasses(partClassesResponse.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    
    useEffect(() => {
      const handleEnterKey = (e) => {
      if (e.key === 'Enter') {
      e.preventDefault();
      const form = e.target.form;
      const fields = Array.from(form.elements).filter(el => (
        (el.tagName === 'INPUT' && !el.disabled) ||
        (el.tagName === 'TEXTAREA' && !el.disabled) ||
        (el.tagName === 'SELECT' && !el.disabled)
      ));      const currentFieldIndex = fields.findIndex(el => el === document.activeElement);
      const nextFieldIndex = currentFieldIndex + 1;
      if (nextFieldIndex < fields.length) {
        fields[nextFieldIndex].focus();
      }
      }
      };
      
      document.addEventListener('keydown', handleEnterKey);
      
      return () => {
      document.removeEventListener('keydown', handleEnterKey);
      };
      }, []);
  // Handle form field change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle photo upload
  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      Photo: file,
    });

    // Preview the uploaded image
    const reader = new FileReader();
    reader.onloadend = () => {
      setPhotoPreview(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    } else {
      setPhotoPreview(null);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const formDataToSubmit = new FormData();
    Object.keys(formData).forEach(key => {
      formDataToSubmit.append(key, formData[key]);
    });
    
    try {
      // Send POST request to the API
      const response = await axios.post('https://subk.education.com.ly/back/api/parts', formDataToSubmit, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      toast.success('تمت الاضافة بنجاح');
      props.parentFunction();

      setPartModal(false); // Close modal on success
      setFormData({}); // Reset form data
      setPhotoPreview(null); // Reset photo preview
    } catch (error) {
      console.error('There was an error submitting the form!', error);
      setErrors('Failed to submit part data.');
    }
  };

  useImperativeHandle(ref, () => ({
    showPartModal() {
      fetchSuppliersAndPartClasses()
      setPartModal(true);
    },
  }));
  const [selectedOption, setSelectedOption] = useState(null);
  const countries = [
    { value: "afghanistan", label: "Afghanistan" },
    { value: "albania", label: "Albania" },
    { value: "algeria", label: "Algeria" },
    { value: "andorra", label: "Andorra" },
    { value: "angola", label: "Angola" },
    { value: "antigua-and-barbuda", label: "Antigua and Barbuda" },
    { value: "argentina", label: "Argentina" },
    { value: "armenia", label: "Armenia" },
    { value: "australia", label: "Australia" },
    { value: "austria", label: "Austria" },
    { value: "azerbaijan", label: "Azerbaijan" },
    { value: "bahamas", label: "Bahamas" },
    { value: "bahrain", label: "Bahrain" },
    { value: "bangladesh", label: "Bangladesh" },
    { value: "barbados", label: "Barbados" },
    { value: "belarus", label: "Belarus" },
    { value: "belgium", label: "Belgium" },
    { value: "belize", label: "Belize" },
    { value: "benin", label: "Benin" },
    { value: "bhutan", label: "Bhutan" },
    { value: "bolivia", label: "Bolivia" },
    { value: "bosnia-and-herzegovina", label: "Bosnia and Herzegovina" },
    { value: "botswana", label: "Botswana" },
    { value: "brazil", label: "Brazil" },
    { value: "brunei", label: "Brunei" },
    { value: "bulgaria", label: "Bulgaria" },
    { value: "burkina-faso", label: "Burkina Faso" },
    { value: "burundi", label: "Burundi" },
    { value: "cabo-verde", label: "Cabo Verde" },
    { value: "cambodia", label: "Cambodia" },
    { value: "cameroon", label: "Cameroon" },
    { value: "canada", label: "Canada" },
    { value: "chad", label: "Chad" },
    { value: "chile", label: "Chile" },
    { value: "china", label: "China" },
    { value: "colombia", label: "Colombia" },
    { value: "comoros", label: "Comoros" },
    { value: "congo", label: "Congo" },
    { value: "costa-rica", label: "Costa Rica" },
    { value: "croatia", label: "Croatia" },
    { value: "cuba", label: "Cuba" },
    { value: "cyprus", label: "Cyprus" },
    { value: "czech-republic", label: "Czech Republic" },
    { value: "denmark", label: "Denmark" },
    { value: "djibouti", label: "Djibouti" },
    { value: "dominica", label: "Dominica" },
    { value: "dominican-republic", label: "Dominican Republic" },
    { value: "ecuador", label: "Ecuador" },
    { value: "egypt", label: "Egypt" },
    { value: "el-salvador", label: "El Salvador" },
    { value: "estonia", label: "Estonia" },
    { value: "eswatini", label: "Eswatini" },
    { value: "ethiopia", label: "Ethiopia" },
    { value: "fiji", label: "Fiji" },
    { value: "finland", label: "Finland" },
    { value: "france", label: "France" },
    { value: "gabon", label: "Gabon" },
    { value: "gambia", label: "Gambia" },
    { value: "georgia", label: "Georgia" },
    { value: "germany", label: "Germany" },
    { value: "ghana", label: "Ghana" },
    { value: "greece", label: "Greece" },
    { value: "grenada", label: "Grenada" },
    { value: "guatemala", label: "Guatemala" },
    { value: "guinea", label: "Guinea" },
    { value: "guyana", label: "Guyana" },
    { value: "haiti", label: "Haiti" },
    { value: "honduras", label: "Honduras" },
    { value: "hungary", label: "Hungary" },
    { value: "iceland", label: "Iceland" },
    { value: "india", label: "India" },
    { value: "indonesia", label: "Indonesia" },
    { value: "iran", label: "Iran" },
    { value: "iraq", label: "Iraq" },
    { value: "ireland", label: "Ireland" },
    { value: "israel", label: "Israel" },
    { value: "italy", label: "Italy" },
    { value: "jamaica", label: "Jamaica" },
    { value: "japan", label: "Japan" },
    { value: "jordan", label: "Jordan" },
    { value: "kazakhstan", label: "Kazakhstan" },
    { value: "kenya", label: "Kenya" },
    { value: "kiribati", label: "Kiribati" },
    { value: "kuwait", label: "Kuwait" },
    { value: "kyrgyzstan", label: "Kyrgyzstan" },
    { value: "laos", label: "Laos" },
    { value: "latvia", label: "Latvia" },
    { value: "lebanon", label: "Lebanon" },
    { value: "lesotho", label: "Lesotho" },
    { value: "liberia", label: "Liberia" },
    { value: "libya", label: "Libya" },
    { value: "liechtenstein", label: "Liechtenstein" },
    { value: "lithuania", label: "Lithuania" },
    { value: "luxembourg", label: "Luxembourg" },
    { value: "madagascar", label: "Madagascar" },
    { value: "malawi", label: "Malawi" },
    { value: "malaysia", label: "Malaysia" },
    { value: "maldives", label: "Maldives" },
    { value: "mali", label: "Mali" },
    { value: "malta", label: "Malta" },
    { value: "marshall-islands", label: "Marshall Islands" },
    { value: "mauritania", label: "Mauritania" },
    { value: "mauritius", label: "Mauritius" },
    { value: "mexico", label: "Mexico" },
    { value: "micronesia", label: "Micronesia" },
    { value: "moldova", label: "Moldova" },
    { value: "monaco", label: "Monaco" },
    { value: "mongolia", label: "Mongolia" },
    { value: "montenegro", label: "Montenegro" },
    { value: "morocco", label: "Morocco" },
    { value: "mozambique", label: "Mozambique" },
    { value: "myanmar", label: "Myanmar" },
    { value: "namibia", label: "Namibia" },
    { value: "nauru", label: "Nauru" },
    { value: "nepal", label: "Nepal" },
    { value: "netherlands", label: "Netherlands" },
    { value: "new-zealand", label: "New Zealand" },
    { value: "nicaragua", label: "Nicaragua" },
    { value: "niger", label: "Niger" },
    { value: "nigeria", label: "Nigeria" },
    { value: "north-korea", label: "North Korea" },
    { value: "north-macedonia", label: "North Macedonia" },
    { value: "norway", label: "Norway" },
    { value: "oman", label: "Oman" },
    { value: "pakistan", label: "Pakistan" },
    { value: "palau", label: "Palau" },
    { value: "panama", label: "Panama" },
    { value: "papua-new-guinea", label: "Papua New Guinea" },
    { value: "paraguay", label: "Paraguay" },
    { value: "peru", label: "Peru" },
    { value: "philippines", label: "Philippines" },
    { value: "poland", label: "Poland" },
    { value: "portugal", label: "Portugal" },
    { value: "qatar", label: "Qatar" },
    { value: "romania", label: "Romania" },
    { value: "russia", label: "Russia" },
    { value: "rwanda", label: "Rwanda" },
    { value: "samoa", label: "Samoa" },
    { value: "san-marino", label: "San Marino" },
    { value: "saudi-arabia", label: "Saudi Arabia" },
    { value: "senegal", label: "Senegal" },
    { value: "serbia", label: "Serbia" },
    { value: "seychelles", label: "Seychelles" },
    { value: "sierra-leone", label: "Sierra Leone" },
    { value: "singapore", label: "Singapore" },
    { value: "slovakia", label: "Slovakia" },
    { value: "slovenia", label: "Slovenia" },
    { value: "solomon-islands", label: "Solomon Islands" },
    { value: "somalia", label: "Somalia" },
    { value: "south-africa", label: "South Africa" },
    { value: "south-korea", label: "South Korea" },
    { value: "spain", label: "Spain" },
    { value: "sri-lanka", label: "Sri Lanka" },
    { value: "sudan", label: "Sudan" },
    { value: "suriname", label: "Suriname" },
    { value: "sweden", label: "Sweden" },
    { value: "switzerland", label: "Switzerland" },
    { value: "syria", label: "Syria" },
    { value: "taiwan", label: "Taiwan" },
    { value: "tajikistan", label: "Tajikistan" },
    { value: "tanzania", label: "Tanzania" },
    { value: "thailand", label: "Thailand" },
    { value: "timor-leste", label: "Timor-Leste" },
    { value: "togo", label: "Togo" },
    { value: "tonga", label: "Tonga" },
    { value: "trinidad-and-tobago", label: "Trinidad and Tobago" },
    { value: "tunisia", label: "Tunisia" },
    { value: "turkey", label: "Turkey" },
    { value: "turkmenistan", label: "Turkmenistan" },
    { value: "tuvalu", label: "Tuvalu" },
    { value: "uganda", label: "Uganda" },
    { value: "ukraine", label: "Ukraine" },
    { value: "united-arab-emirates", label: "United Arab Emirates" },
    { value: "united-kingdom", label: "United Kingdom" },
    { value: "united-states", label: "United States" },
    { value: "uruguay", label: "Uruguay" },
    { value: "uzbekistan", label: "Uzbekistan" },
    { value: "vanuatu", label: "Vanuatu" },
    { value: "vatican-city", label: "Vatican City" },
    { value: "venezuela", label: "Venezuela" },
    { value: "vietnam", label: "Vietnam" },
    { value: "yemen", label: "Yemen" },
    { value: "zambia", label: "Zambia" },
    { value: "zimbabwe", label: "Zimbabwe" },
  ];
  const handleSelect = (selectedOption) => {
    setFormData({
      ...formData,
      CountryOfManufacture: selectedOption.value, // Store the value of the selected option
    });
    setSelectedOption(selectedOption); // Update the selected option state
  };
  return (
    <Modal className="modal fade" size="xl" show={partModal} centered>
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="modal-title fs-5">تفاصيل القطعة</h1>
          <button type="button" style={{ marginLeft: 0 }} className="btn-close" onClick={() => setPartModal(false)}></button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="row">
              <div className="col-xl-12">
                {errors && <div className="alert alert-danger">{errors}</div>}
              </div>
              <div className="col-xl-2">
                <label className="form-label mt-3">الصورة</label>
                <div className="blog-img image-hight" style={{ border: 'black dashed 1px', height: '200px' }}>
                  {photoPreview && (
                    <img src={photoPreview} alt="" style={{ height: '200px', width: '100%' }} />
                  )}
                </div>
                <input
                  name="Photo"
                  accept="image/*"
                  onChange={handlePhotoChange}
                  className="form-control"
                  type="file"
                  id="formFile"
                />
              </div>

              <div className="col-xl-10">
                <div className="row">
                  <div className="col-xl-4">
                    <label className="form-label mt-3"> اسم القطعة   </label>
                    <input
                      className="form-control"
                      type="text"
                      name="PartName"
                      value={formData.PartName}
                      onChange={handleChange}
                       pattern="[a-zA-Z\u0600-\u06FF\s]+"
                                            title="الرجاء إدخال أحرف فقط، الفراغات، والحروف العربية"
                    />
                  </div>
                  <div className="col-xl-4">
                    <label className="form-label mt-3">رقم القطعة </label>
                    <input
                      className="form-control"
                      type="text"
                      name="PartNumber"
                      value={formData.PartNumber}
                      onChange={handleChange}
                    />
                  </div>
                  
                   
                  {/* <div className="col-xl-4">
                    <label className="form-label mt-3">المورد</label>
                    <select
                      className="form-control"
                      name="SupplierID"
                      value={formData.SupplierID}
                      onChange={handleChange}
                    >
                      <option value="">اختر</option>
                      {suppliers.map(supplier => (
                        <option key={supplier.SupplierID} value={supplier.SupplierID}>
                          {supplier.SupplierName}
                        </option>
                      ))}
                    </select>
                  </div> */}
                  <div className="col-xl-4">
                    <label className="form-label mt-3">توافق السيارة</label>
                    <input
                      className="form-control"
                      type="text"
                      name="VehicleCompatibility"
                      value={formData.VehicleCompatibility}
                      onChange={handleChange}
                    />
                  </div>

                  {/* PartClassID Dropdown */}
                  <div className="col-xl-4">
                    <label className="form-label mt-3">تصنيف القطعة</label>
                    <select
                      className="form-control"
                      name="PartClassID"
                      value={formData.PartClassID}
                      onChange={handleChange}
                    >
                      <option value="">اختر</option>
                      {partClasses.map(partClass => (
                        <option key={partClass.PartClassID} value={partClass.PartClassID}>
                          {partClass.PartClassName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-xl-4">
                    <label className="form-label mt-3">كود الصنف</label>
                    <input
                      className="form-control"
                      type="text"
                      name="ProductCode"
                      value={formData.ProductCode}
                      onChange={handleChange}
                    />
                  </div>
                  
                  <div className="col-xl-4">
                    <label className="form-label mt-3">الشركة المصنعة</label>
                    <input
                      className="form-control"
                      type="text"
                      name="Manufacturer"
                      value={formData.Manufacturer}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-xl-4">
                    <label className="form-label mt-3">بلد التصنيع</label>
                    <Select
                    name="CountryOfManufacture"
                  styles={{background: '#fff',
                    color:' #6e6e6e',
                    lineheight: '1.5rem',
                    fontsize:' 13px',
                    borderradius: '0.375rem',
                    padding: '0.375rem 1rem',
                    bordercolor: 'rgba(0, 0, 0, 0.1)'}}
                    defaultValue={selectedOption}
                    onChange={handleSelect}
                    options={countries}
                    
                  />
                  </div>
                  <div className="col-xl-4">
                    <label className="form-label mt-3">ملاحظات</label>
                    <textarea
                      className="form-control"
                      name="Notes"
                      value={formData.Notes}
                      onChange={handleChange}
                    />
                  </div>
                 
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button type="submit" className="btn btn-primary">حفظ</button>
            <button
              type="button"
              className="btn btn-danger light"
              onClick={() => setPartModal(false)}
            >
              الغاء
            </button> 
          </div>
        </form>
        <ToastContainer />
      </div>
    </Modal>
  );
});

export default PartForm;
